module.exports = __webpack_public_path__ + "media/images/games/world_culture_awareness/5-81f5f1b599bcdcb5c3b9e534c18b3b56.png";